import { useParams, Navigate, Link } from "react-router-dom";
import { SEO, Reveal, Eyebrow } from "@/components/motion";
import { LEGAL_CONTENT } from "@/data/content";

export default function Legal() {
  const { slug } = useParams();
  const doc = LEGAL_CONTENT[slug];
  if (!doc) return <Navigate to="/" replace />;

  return (
    <main data-testid={`legal-${slug}`} className="mx-auto max-w-3xl px-5 sm:px-8 pt-32 sm:pt-44 pb-24">
      <SEO title={`${doc.title} | HOMELARA LTD`} description={`${doc.title} for HOMELARA LTD, professional cleaning services in London Zones 1 & 2.`} />
      <Reveal>
        <Eyebrow>Legal</Eyebrow>
        <h1 className="mt-4 font-serif text-4xl sm:text-5xl tracking-tight text-ink">{doc.title}</h1>
        <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.2em] text-faint">{doc.updated}</p>
        <p className="mt-6 text-base leading-relaxed text-body">{doc.intro}</p>
      </Reveal>
      <div className="mt-12 space-y-10">
        {doc.sections.map((s, i) => (
          <Reveal key={i} delay={i * 0.04}>
            <h2 className="font-serif text-2xl tracking-tight text-blue">{s.h}</h2>
            <p className="mt-3 text-base leading-relaxed text-body">{s.p}</p>
          </Reveal>
        ))}
      </div>
      <Reveal className="mt-14">
        <p className="text-sm text-faint">
          Questions about this policy? Email{" "}
          <a href="mailto:lauraflorez@homelara.uk" className="text-blue underline underline-offset-4">
            lauraflorez@homelara.uk
          </a>{" "}
          or <Link to="/contact" className="text-blue underline underline-offset-4">contact us</Link>.
        </p>
      </Reveal>
    </main>
  );
}
